function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Letters"
}, /*#__PURE__*/React.createElement("path", {
  d: "M399.3872,484.9819q0,26.0244-9.2944,46.0591t-26.5064,30.98Q346.3724,572.97,323.93,572.9688q-33.8732,0-54.8028-24.0967-20.9318-24.0937-20.93-64.9917v-28.916q0-25.8861,9.2944-45.99t26.5752-31.05q17.2785-10.9467,39.5874-10.9467,22.4421,0,39.7251,10.9467,17.2785,10.9468,26.644,31.1192,9.3625,20.173,9.3633,45.9214Zm-7.4355-30.2929q0-36.3516-18.4512-58.314-18.4534-21.9616-49.8457-21.9624-30.9815,0-49.4326,21.8247-18.4535,21.8254-18.4512,59.4155v29.3291q0,23.9591,8.3306,42.3413t23.7524,28.2959q15.42,9.9141,36.0762,9.9141,31.3945,0,49.708-21.8936,18.3113-21.8928,18.3135-59.7592Z",
  transform: "translate(-248.1978 -366.9771)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.2813,369.731V505.4985q0,31.8077-18.4512,49.6382-18.4535,17.8345-49.9834,17.8321-31.533,0-49.9834-17.8321-18.4534-17.83-18.5889-49.0874V369.731H464.71V505.2231q0,27.8153,16.73,44.0621,16.73,16.2495,44.4068,16.248t44.3379-16.248q16.6588-16.2451,16.6611-44.2V369.731Z",
  transform: "translate(-248.1978 -366.9771)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M737.6772,484.4312H668.1411v85.7836h-7.4355V369.731h63.8906q30.1553,0,47.9868,15.56,17.8308,15.5618,17.8316,42.2725a54.4777,54.4777,0,0,1-12.7369,35.87,53.8948,53.8948,0,0,1-32.4272,19.0708l53.5635,85.7837v1.9277h-7.8487Zm-69.5361-7.4356h63.2022q23.1327,0,37.3842-14.0449T782.979,427.563q0-23.4075-15.7661-36.9024-15.7683-13.4934-43.1675-13.4941H668.1411Z",
  transform: "translate(-248.1978 -366.9771)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1069.4951,377.1665H996.5166V570.2148h-7.4355V377.1665H916.1025V369.731h153.3926Z",
  transform: "translate(-248.1978 -366.9771)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1226.66,470.7993H1126.1426v91.98h114.5625v7.4355H1118.707V369.731h121.9981v7.4355H1126.1426v86.1973H1226.66Z",
  transform: "translate(-248.1978 -366.9771)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1398.9717,510.3179h-98.1768l-22.3066,59.8969h-8.124l75.0439-200.4838h9.0879L1429.54,570.2148h-8.124Zm-95.4229-7.4356h92.669l-46.2657-124.2011Z",
  transform: "translate(-248.1978 -366.9771)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1486.4639,369.731l82.48,189.6059,82.7548-189.6059h10.878V570.2148h-7.4356V380.7466l-83.1679,189.4682h-5.9209L1483.2969,381.71V570.2148h-7.4356V369.731Z",
  transform: "translate(-248.1978 -366.9771)"
}));

var SvgTeamLetters = function SvgTeamLetters(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "team_letters",
    width: 1414.3784,
    height: 205.9917,
    viewBox: "0 0 1414.3784 205.9917",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeamLetters, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/team_letters.325467de.svg";
export { ForwardRef as ReactComponent };